import { CallRecordingCard } from "@/components/user-sheet/records/CallRecordingCard";

import { Column, ErrorText, LoadingIndicator } from "@/components";

import { dates } from "@/lib/dates";
import { formatting } from "@/lib/formatting";
import { transcript } from "@/lib/transcript";
import { CallHistoryStafferCall } from "@/types";

export const CandidacyStafferCallsList = ({
  calls,
  candidateFirstName,
  isError,
  isPending,
}: {
  calls: CallHistoryStafferCall[];
  candidateFirstName: string;
  isError: boolean;
  isPending: boolean;
}) => {
  /* Render */
  const renderRecordingCard = (call: CallHistoryStafferCall) => {
    const stafferName = `${call.user.firstName} ${call.user.lastName}`.trim();

    return (
      <CallRecordingCard
        audioSrc={call.audioUrl}
        dateLabel={dates.formatIsoDateTimeForUser(call.startedAt) ?? "—"}
        direction={call.direction}
        downloadFilename={`staffer-call-${candidateFirstName}-${call.startedAt}.mp3`
          .toLowerCase()
          .replace(/\s+/g, "-")}
        getRoleLabel={(role) =>
          role === "staffer" ? stafferName || "Staffer" : candidateFirstName
        }
        isMissed={!call.audioUrl && !call.transcript}
        key={call.id}
        summary={formatting.callSummaryHtml(call.summary)}
        title={stafferName ? `Call with ${stafferName}` : "Staffer call"}
        transcriptLines={transcript.parseLines(call.transcript)}
        type="staffer"
      />
    );
  };

  const render = () => {
    if (isPending) {
      return <LoadingIndicator variant="medium" />;
    }
    if (isError) {
      return <ErrorText errorMessage="Error retrieving staffer calls." />;
    }
    if (!calls.length) {
      return null;
    }

    return <Column className="gap-5">{calls.map(renderRecordingCard)}</Column>;
  };

  return render();
};
